<template>
    <transition
        v-bind:css="false"
        mode="out-in"
        v-on:enter="enter"
        v-on:after-enter="afterEnter"
        v-on:before-enter="beforeEnter"
        v-on:leave="leave">
        <slot />
    </transition>
</template>
<script>
    import $ from "jquery";

    export default {
        inject: {
            viewport: {
                from: "viewport",
                default: null
            }
        },
        props: {
            pageSlideLeft: { type: Boolean, required: true },
            scrollToTopOverride: { type: Function, required: false, default: null }
        },
        emits: ["page-transition-start", "page-transition-end"],
        methods: {
            leave(el, done) {
                this.$emit("page-transition-start");

                if (this.scrollToTopOverride && typeof this.scrollToTopOverride === "function") {
                    // If a custom scrollToTop function is provided, call it
                    this.scrollToTopOverride();
                } else {
                    const viewportParent = this.viewport?.$el?.parentNode;
                    if (!viewportParent) {
                        // If there is no viewport parent, scroll the main page content to the top
                        $("#NavLayoutPageContent").animate({ scrollTop: 0 }, { queue: false });
                    } else {
                        // If there is a viewport parent, scroll to the header of the form
                        // Try to scroll the viewport if it is scrollable, otherwise scroll main page content
                        const scrollElement =
                            viewportParent.scrollHeight > viewportParent.clientHeight
                                ? $(viewportParent)
                                : $("#NavLayoutPageContent");

                        // If we find a scrollable element, scroll it to the project form header
                        if (scrollElement.length) {
                            // Calculate the amount to scroll the viewport to make the header visible
                            let scrollAmount =
                                $("#ProjectFormHeader").offset().top - scrollElement[0].getBoundingClientRect().top;

                            // Add a bit of vertical padding above the header to make sure it's not right at the top of the viewport
                            const VERTICAL_PADDING = 10;
                            scrollAmount -= VERTICAL_PADDING;

                            // If the header is above the top of the scrollElement, scroll the viewport so the header is in view
                            if (scrollAmount < 0) {
                                scrollElement.animate(
                                    { scrollTop: scrollElement.scrollTop() + scrollAmount },
                                    { queue: false }
                                );
                            }
                        } else {
                            // If we can't find a scrollable element, scroll the entire window to the top
                            if ($(window).scrollTop() != 0) {
                                $("html, body").animate({ scrollTop: 0 }, { queue: false });
                            }
                        }
                    }
                }

                // Flip to next page
                const $el = $(el);
                this.prevPageHeight = $el.outerHeight();
                const leftPosition = this.pageSlideLeft ? -100 : 100;
                $el.animate({ left: `${leftPosition}%` }, done);
            },
            beforeEnter(el) {
                const $el = $(el);
                this.nextPageHeight = $el.outerHeight();
                const leftPosition = this.pageSlideLeft ? 100 : -100;
                $el.css({ left: `${leftPosition}%`, height: `${this.prevPageHeight}px` });
            },
            enter(el, done) {
                const $el = $(el);
                if (this.nextPageHeight === 0) {
                    this.nextPageHeight = $el.outerHeight();
                }
                $el.animate({ left: "0%", height: `${this.nextPageHeight}px` }, function () {
                    $el.removeAttr("style");
                    done();
                });
            },
            afterEnter() {
                this.$emit("page-transition-end");
            }
        }
    };
</script>
